// extracted by mini-css-extract-plugin
export default {"userLink":"author_userLink__7Cra7","avatar":"author_avatar__i1z8f","userName":"author_userName__39At0"};